import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import type { CreateInvoiceInput } from '@accounting/shared';
import { useCreateInvoice } from '../../hooks/useInvoices';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import { InvoiceForm } from '../../components/invoices/InvoiceForm';
import { ApiError } from '../../lib/api';

export const Route = createFileRoute('/_auth/invoices/new')({
  component: NewInvoicePage,
});

function NewInvoicePage() {
  const companyId = useActiveCompanyId();
  const navigate = useNavigate();
  const create = useCreateInvoice(companyId);

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  const errorMessage =
    create.error instanceof ApiError
      ? (create.error.body as { error?: string } | null)?.error ?? 'Could not create invoice'
      : create.error?.message;

  return (
    <div>
      <Link to="/invoices" style={{ fontSize: 13 }}>
        ← Invoices
      </Link>
      <h1 style={{ fontSize: 24, margin: '8px 0 16px' }}>New invoice</h1>

      <InvoiceForm
        companyId={companyId}
        submitLabel="Save & issue invoice"
        submitting={create.isPending}
        errorMessage={errorMessage}
        cancelTo="/invoices"
        onSubmit={(input) =>
          create.mutate(input as CreateInvoiceInput, {
            onSuccess: (inv) => void navigate({ to: '/invoices/$id', params: { id: inv.id } }),
          })
        }
        onSaveDraft={(input) =>
          create.mutate({ ...input, asDraft: true } as CreateInvoiceInput, {
            onSuccess: (inv) => void navigate({ to: '/invoices/$id', params: { id: inv.id } }),
          })
        }
        onSubmitAndNew={(input, reset) =>
          create.mutate(input as CreateInvoiceInput, {
            onSuccess: () => reset(),
          })
        }
      />
    </div>
  );
}
